import type { ProjectLimitFieldOption } from './types';

export const getProjectLimitRows = (
  projectLimitFields: ProjectLimitFieldOption[] = [],
  fallbackRows: Array<[string, React.ReactNode, boolean?]>,
): Array<[string, React.ReactNode, boolean?]> =>
  projectLimitFields.length
    ? projectLimitFields.map((field) => [field.label, field.limit, true])
    : fallbackRows;

export const getProjectLimitField = (projectLimitFields: ProjectLimitFieldOption[] = [], fieldPath: string) =>
  projectLimitFields.find((field) => field.fieldPath === fieldPath);

export const getProjectLimitText = (projectLimitFields: ProjectLimitFieldOption[] = [], fieldPath: string, fallback: string) =>
  getProjectLimitField(projectLimitFields, fieldPath)?.limit || fallback;

export const getProjectLimitMax = (projectLimitFields: ProjectLimitFieldOption[] = [], fieldPath: string, fallback: number) =>
  getProjectLimitField(projectLimitFields, fieldPath)?.max ?? fallback;

export const getProjectLimitMin = (projectLimitFields: ProjectLimitFieldOption[] = [], fieldPath: string, fallback: number) =>
  getProjectLimitField(projectLimitFields, fieldPath)?.min ?? fallback;
